import { render, staticRenderFns } from "./error-logger.vue?vue&type=template&id=893fbf70&"
import script from "./error-logger.vue?vue&type=script&lang=js&"
export * from "./error-logger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports